jQuery(function($) {
  // -----------------------------------------------------------------------
  // Slick Slider - Our Sectors
  // -----------------------------------------------------------------------
  $(document).ready(function() {
    $('.our-sectors-slider__slick-slider--mobile').slick({
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><img src="content/themes/us-digital/assets/images/svgs/icon-cta-arrow-white-left.svg"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="content/themes/us-digital/assets/images/svgs/icon-cta-arrow-white-right.svg"></button>',
    });

    setTimeout(function() {
      if ($('.slick-prev, .slick-next').length) {
        $('.slider-navigation-mobile').append($('.slick-prev, .slick-next'));
      }
    }, 100);

    $(window).on('resize', function() {
      setTimeout(function() {
        if ($('.slick-prev, .slick-next').length && $('.slider-navigation-mobile .slick-prev').length === 0) {
          $('.slider-navigation-mobile').append($('.slick-prev, .slick-next'));
        }
      }, 300);
    });

    $('.our-sectors-slider__slick-slider--desktop').slick({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    function isValidSlideBackground(bgImage) {
      if (!bgImage) {
        return false;
      }

      var normalized = $.trim(bgImage).toLowerCase();

      return (
        normalized !== '' &&
        normalized !== 'none' &&
        normalized !== 'url("none")' &&
        normalized !== "url('none')" &&
        normalized !== 'url(none)'
      );
    }

    function resolveSlideBackground($image) {
      var bgImage = $image.attr('data-original-bg');

      if (!isValidSlideBackground(bgImage)) {
        var dataBack = $image.attr('data-back');

        if (dataBack) {
          bgImage = /^url\(/i.test(dataBack) ? dataBack : 'url("' + dataBack + '")';
        }
      }

      return isValidSlideBackground(bgImage) ? bgImage : null;
    }

    // Store each slide’s background in a data attribute & preload images
    $('.our-sectors-slider__image').each(function() {
      var $image = $(this);
      var bgImage = resolveSlideBackground($image);

      if (!bgImage) {
        bgImage = $image.css('background-image');

        if (!isValidSlideBackground(bgImage)) {
          return;
        }
      }

      $image.attr('data-original-bg', bgImage);
      $('<img/>')[0].src = bgImage.replace(/url\(["']?|["']?\)/g, '');
    });

    let firstHover = true;
    let hoverTimeout, leaveTimeout; // For smooth transitions

    // Show hovered slide’s image full-screen & add 'current-active' class
    $('.our-sectors-slider__slick-slider--desktop').on('mouseenter', '.slick-slide', function() {
      let $this = $(this);
      clearTimeout(leaveTimeout);
      let bgImage = resolveSlideBackground($this.find('.our-sectors-slider__image'));

      if (bgImage) {
        hoverTimeout = setTimeout(function() {
          $('.our-sectors-slider__fullBG').css({
            'background-image': bgImage,
            opacity: '1',
            transition: 'opacity 1s ease-out',
          });

          // Add current-active class
          $('.slick-slide').removeClass('current-active');
          $this.addClass('current-active');
        });
      }

      // Remove individual slide backgrounds after the first hover
      if (firstHover) {
        $('.our-sectors-slider__image').css('background-image', 'none');
        firstHover = false;
      }
    });

    // Restore backgrounds when the mouse leaves the slider & remove 'current-active'
    $('.our-sectors-slider__slick-slider--desktop').on('mouseleave', function() {
      clearTimeout(hoverTimeout);
      leaveTimeout = setTimeout(function() {
        $('.our-sectors-slider__fullBG').css({
          opacity: '0',
        });

        $('.slick-slide').removeClass('current-active');

        // Restore original slide backgrounds
        $('.our-sectors-slider__image').each(function() {
          var $image = $(this);
          var originalBg = resolveSlideBackground($image);

          if (originalBg) {
            $image.css('background-image', originalBg);
          }
        });

        firstHover = true;
      });
    });
  });

  setTimeout(function() {
    if ($('.our-sectors-slider__slick-slider--desktop .slick-dots').length) {
      $('.slider-navigation-desktop').append($('.our-sectors-slider__slick-slider--desktop .slick-dots'));
    }
  }, 100);

  $(window).on('resize', function() {
    setTimeout(function() {
      if ($('.our-sectors-slider__slick-slider--desktop .slick-dots').length && $('.slider-navigation-desktop .slick-dots').length === 0) {
        $('.slider-navigation-desktop').append($('.our-sectors-slider__slick-slider--desktop .slick-dots'));
      }
    }, 300);
  });

  // -----------------------------------------------------------------------
  // Slick Slider - Leading Brands
  // -----------------------------------------------------------------------
  $('.logos-slider__slick-slider').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  });

  // -----------------------------------------------------------------------
  // Slick Slider -  Case Studies Slider
  // -----------------------------------------------------------------------
  var $caseStudiesMainSlider = $('.case-studies-slider__slick-slider');
  var $caseStudiesNavSlider = $('.case-studies-slider__nav');

  $caseStudiesMainSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    autoplay: true,
    autoplaySpeed: 10000,
    infinite: true,
    asNavFor: '.case-studies-slider__nav',
    speed: 500,
  });

  // Thumbnail Slider - Syncs with Main Slider
  $caseStudiesNavSlider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.case-studies-slider__slick-slider',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 10000,
    variableWidth: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

  $caseStudiesMainSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $caseStudiesNavSlider.find('.slick-slide').removeClass('slick-current');
    $caseStudiesNavSlider.find('.slick-slide[data-slick-index="' + nextSlide + '"]').addClass('slick-current');
  });

  var counted = false;

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
  }

  function resetCounters() {
    $('.count').each(function() {
      $(this).text('0');
    });
  }

  function animateCounters() {
    $('.case-studies-slider__slide.slick-active .count, .case-studies-stats .count').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');

      $({
        countNum: 0,
      }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 1000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
          },
        }
      );
    });
  }

  $('.case-studies-slider__slick-slider').on('beforeChange', function() {
    if (counted) {
      resetCounters();
    }
  });

  $('.case-studies-slider__slick-slider').on('afterChange', function() {
    if (counted) {
      animateCounters();
    }
  });

  $(window).on('scroll', function() {
    if (!counted && isElementInViewport(document.querySelector('.case-studies-stats'))) {
      counted = true;
      setTimeout(animateCounters, 150);
    }
  });

  // -----------------------------------------------------------------------
  // Slick Slider - Split - What We Do
  // -----------------------------------------------------------------------
  $(document).ready(function() {
    // Init Slick only on mobile slider
    if ($('.split__slider--mobile').length) {
      $('.split__slider--mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        initialSlide: 0,
      });

      // Click handler for split in mobile slider only
      $('.split__slider--mobile .split-list li').click(function() {
        var serviceTitle = $(this).attr('data-title');

        $('.split__slider--mobile .split-list li').removeClass('active');
        $(this).addClass('active');

        $('.split__slider--mobile .split-details').hide();
        $('.split__slider--mobile .split-details[data-title="' + serviceTitle + '"]').fadeIn(1000);

        $('.split__slider--mobile').slick('slickNext');
      });

      // Back button for mobile only
      $('.split__slider--mobile .split__back-btn').click(function() {
        $('.split__slider--mobile').slick('slickGoTo', 0);
        $('.split__slider--mobile .split-list li').removeClass('active');
      });
    }
  });

  $(document).ready(function() {
    // Init Slick only on desktop slider
    if ($('.split__slider--desktop').length) {
      $('.split__slider--desktop').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        initialSlide: 0,
      });

      // Click handler for split in desktop slider only
      $('.split__slider--desktop .split-list li').click(function() {
        var serviceTitle = $(this).attr('data-title');

        $('.split__slider--desktop .split-list li').removeClass('active');
        $(this).addClass('active');

        $('.split__slider--desktop .split-details').hide();
        $('.split__slider--desktop .split-details[data-title="' + serviceTitle + '"]').fadeIn(1000);

        $('.split__slider--desktop').slick('slickNext');
      });

      // Back button for desktop only
      $('.split__slider--desktop .split__back-btn').click(function() {
        $('.split__slider--desktop').slick('slickGoTo', 0);
        $('.split__slider--desktop .split-list li').removeClass('active');
      });
    }
  });

  // -----------------------------------------------------------------------
  // Archive Team
  // -----------------------------------------------------------------------
  jQuery(function($) {
    var $teamNavSlider = $('.team__nav-slider');

    // init slick
    if ($teamNavSlider.length && !$teamNavSlider.hasClass('slick-initialized')) {
      $teamNavSlider.slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        variableWidth: true,
        swipeToSlide: true,
        touchThreshold: 10,
        appendArrows: $('#teamDeptArrows'),
        prevArrow: '<button type="button" class="team__arrow team__arrow--prev" aria-label="Previous">‹</button>',
        nextArrow: '<button type="button" class="team__arrow team__arrow--next" aria-label="Next">›</button>',
        responsive: [{breakpoint: 1200, settings: {slidesToShow: 5}}, {breakpoint: 992, settings: {slidesToShow: 4}}, {breakpoint: 768, settings: {slidesToShow: 3}}, {breakpoint: 480, settings: {slidesToShow: 2}}],
      });
    }

    function filterTeam(filterSlug) {
      var $items = $('.team__item');

      if (!filterSlug || filterSlug === 'all') {
        $items.removeClass('is-hidden');
        return;
      }

      $items.each(function() {
        var depString = $(this).attr('data-departments') || '';
        var depList = depString.split(' ').filter(Boolean);

        if (depList.indexOf(filterSlug) !== -1) {
          $(this).removeClass('is-hidden');
        } else {
          $(this).addClass('is-hidden');
        }
      });
    }

    // Department click
    $(document).on('click', '.team__nav-item', function(e) {
      e.preventDefault();

      $('.team__nav-item').removeClass('team__nav-item--active');
      $(this).addClass('team__nav-item--active');

      var filter = $(this).data('filter');
      var label = $(this)
        .text()
        .trim();

      $('#teamDeptSelected').text(label);
      filterTeam(filter);
    });

    filterTeam('all');
  });
});
